<template>
  <div id="app">
    <b-loading v-if="loading" :is-full-page="true" :active="loading"></b-loading>

    <section v-else-if="error" class="gate gate--error">
      <div class="gate__inner">
        <h1 class="gate__heading">{{ error }}</h1>
        <p class="gate__lede">Check your connection and try again.</p>
        <button type="button" class="tb-btn tb-btn--accent" @click="retry()">RETRY</button>
      </div>
    </section>

    <section v-else-if="!accepted" class="gate gate--terms">
      <div class="gate__inner">
        <h1 class="gate__heading text-funky">{{ info.name }}</h1>

        <div class="gate__panel">
          <p>
            Tambola is a skill based game considered by supreme court of India. {{ info.name }} is completely legal (except in case of assam and odisha) and
            has been designed by strictly following the set of rules stated by indian governing law and jurisdiction. At the same time it is legally registered
            with the appropriate registration authorities.
          </p>
          <ul class="gate__rules">
            <li>None of the employee/agents/director/partner can participate in the game.</li>
            <li>The company will redraw the game incase of server fault or any technical problem on server side during the draw.</li>
            <li>Incase of redraw, no payment will be made on behalf of faulting draw.</li>
            <li>Cancellation of tickets will not be entertained, if there is redraw in the game.</li>
          </ul>
        </div>

        <button type="button" class="tb-btn tb-btn--accent" @click="accept()">ENTER</button>
      </div>
    </section>

    <router-view v-else />

    <notifications group="global" />
  </div>
</template>

<script>
  import { mapState } from "vuex";
  import "firebase/auth";
  import firebase from "firebase/app";

  export default {
    data() {
      return {
        error: null,
        loading: true,
        accepted: false
      };
    },
    computed: {
      ...mapState(["info"])
    },
    async created() {
      try {
        this.$store.dispatch("fetchInfo");
        const route = await this.$store.dispatch("fetchStatus");

        firebase.auth().onAuthStateChanged((user) => {
          this.loading = false;
          if (this.$route.name !== "Admin" && this.$route.name !== "Login") {
            this.$router.push(route);
          } else if (user) {
            // Signed-in staff skip the player-facing terms gate.
            this.accept();
            this.$store.commit("SET_USER", user);
          }
        });
      } catch (error) {
        console.error(error);
        this.loading = false;
        this.error = "Something went wrong!";
      }
    },
    methods: {
      retry() {
        window.location.href = "/";
      },
      accept() {
        this.accepted = true;
      }
    }
  };
</script>

<style>
  #app {
    min-height: 100vh;
    font-family: "Gill Sans", "Gill Sans MT", Calibri, system-ui, -apple-system, "Segoe UI", sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-weight: 600;
    text-align: center;
    word-break: break-word;
  }

  /* Full-screen gates: the terms screen and the fatal-error screen. */
  .gate {
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    padding: 24px 16px calc(24px + env(safe-area-inset-bottom, 0px));
  }

  .gate--terms {
    background: linear-gradient(0deg, rgb(34, 193, 195) 0%, rgb(221, 167, 52) 100%);
  }

  .gate--error {
    background: #1f2430;
  }

  .gate__inner {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    max-width: 560px;
    color: #fff;
  }

  .gate__heading {
    margin: 0;
    font-size: clamp(18px, 5.5vw, 28px);
    line-height: 1.4;
  }

  .gate__lede {
    margin: 0;
    opacity: 0.8;
  }

  .gate__panel {
    padding: 18px;
    border-radius: 14px;
    background: rgba(0, 0, 0, 0.82);
    font-size: clamp(13px, 3.6vw, 15px);
    font-weight: 400;
    line-height: 1.65;
    text-align: left;
  }

  .gate__rules {
    margin: 16px 0 0;
    padding-left: 20px;
    list-style: disc;
  }

  .gate__rules li + li {
    margin-top: 8px;
  }
</style>
